import React, { forwardRef, Ref } from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { Select } from '@app/lib/inputs/Select'
import { useProductsQuery } from '@app/queries/Products/Products.queries'

export const ProductSelect = forwardRef(
  (inputProps: ControllerRenderProps<FieldValues, string>, ref: Ref<HTMLButtonElement>) => {
    const { data, error: productsError, loading: productsLoading } = useProductsQuery()
    const productNames = Array.from(new Set(data?.products.items?.map((product) => product.name)))
      .filter(Boolean)
      .sort((a, b) => {
        if (a < b) {
          return -1
        }
        return 1
      })

    const productsOptions = productNames.reduce((acc, item) => {
      return [...acc, { label: item || '', value: item || '' }]
    }, [])

    return (
      <Select
        {...inputProps}
        triggerSize='sm'
        options={productsOptions}
        allowEmpty
        disabled={productsLoading || !!productsError}
        ref={ref}
      />
    )
  }
)
